import { Nullable } from "common/types";
import { Record } from "immutable";

export const queryParamsFromJSON = (data: Partial<IQueryParamsBaseRecord>) => {
  const record = { ...data };

  return new QueryParamsBaseRecord(record);
};

export const toParams = (record: any): any => {
  const params: any = { ...record.toJS() };

  Object.keys(params).forEach((key) => {
    if (params[key] === null || params[key] === undefined || params[key].length === 0) delete params[key];
  });

  return params;
};

export interface IQueryParamsBaseRecord {
  page: number;
  per_page: number;
  query: Nullable<string>;
  sort_by: string;
  sort_order: string;
}

export const defaultQueryParamsBase: IQueryParamsBaseRecord = {
  page: 1,
  per_page: 25,
  query: null,
  sort_by: "sort_order",
  sort_order: "asc",
};

export class QueryParamsBaseRecord extends Record(defaultQueryParamsBase) implements IQueryParamsBaseRecord {}
